import { createContext, useContext } from 'react';
import { Countries, getDefaultForCountry, Languages, } from '@merchant-portal/mp-models';
export const LocaleContext = createContext({
    countryCode: Countries.SE,
    language: Languages.SWEDISH,
    setLocale: () => {
        /* Setter */
    },
});
const localeChanged = (context, eventData) => context &&
    eventData &&
    eventData.countryCode &&
    context.countryCode !== eventData.countryCode;
export const updateLocaleOnEvent = (context, eventData) => {
    if (context.setLocale && localeChanged(context, eventData)) {
        context.setLocale({
            countryCode: eventData.countryCode,
            language: getDefaultForCountry(eventData.countryCode),
        });
    }
};
export const useLocaleContext = () => useContext(LocaleContext);
